<template>
  <main role="main">

    <div style="flex:1 1 auto" :class="getBackgroundUiClass()">

      <!-- Navigation -->
      <page-header nav="0"></page-header>
      <!-- Navigation -->

      <!-- Masthead -->
      <header class="masthead text-white text-center hero-height" style="position:relative;cursor:pointer" :class="getBackgroundUiClass()" @click="$router.push({name:'Signup'})" >
        <div class="overlay"></div>
        <div class="container">
          <div class="d-none d-lg-block">            
            <div class="row mt-5 pt-5" >
              <div class="col-4 mt-4">
                <div class="mx-auto">                
                  <h2>
                    <i class="fas fa-fw fa-check-double mr-1 fa-lg"></i>
                    <br/>PCB Manufacturing<br/>Analysis + API
                  </h2>
                  <p class="font-weight-bold lead mb-0">Prevents Manufacturing Issues and PCB Failures!</p>
                </div>
                <div class="d-lg-none">
                  <h4 class="text-center"></h4>
                </div>
              </div>

              <div class="col-5">
                <div class="mx-auto">
                  <h2>
                    <span class="fa-stack text-success">
                      <i class="fas fa-fw fa-money-bill-alt mr-1 fa-lg"></i>
                      <i class="fas fa-slash text-danger fa-lg fa-stack-1x"></i>
                    </span>
                    <br/>PCB Failures are a<br/>Significant Concern!
                  </h2>
                  <p title="" class="font-weight-bold lead mb-0"><a class="text-light" target="_blank" href="https://www.autoevolution.com/news/2024-kia-sportage-recalled-over-shorting-circuit-board-235310.html"><u>Companies Lose Millions in Product<br/>Recalls and Damaged Reputations</u><i class="fas fa-fw fa-external-link-alt ml-1"></i></a></p>
                </div>              
              </div>

              <div class="col-3 mt-4">
                <div class="mx-auto">
                  <h2>
                    <i class="fas fa-fw fa-rocket mr-1 fa-lg text-warning"></i>
                    <br/>PCB market is<br/>Growing Fast
                  </h2>
                  <p class="font-weight-bold lead mb-0">Globally Projected to Exceed <b>$130 Billion by 2030</b></p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-lg-none">
            <div class="row" >
              <div class="col-12 mt-3 pt-3">
                <div class="mx-auto">                
                  <h2><i class="fas fa-fw fa-check-double mr-1 fa-lg"></i><br/>PCB Manufacturing<br/>Analysis + API</h2>
                  <p class="font-weight-bold lead mb-0">Prevents Manufacturing Issues<br/>and PCB Failures!</p>
                </div>
                <div class="d-lg-none">
                  <h4 class="text-center"></h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- TODO: VIDEO PLAYER
      <div class="row m-3 py-3" :class="getBackgroundPaneClass()">
        <b-img src="/images/landing/pcbpreflight_dashboard.png" fluid class="mx-auto" alt="PCB Preflight - Job Dashboard" title="PCB Preflight - Job Dashboard" @click="$router.push({name:'Signup'})" style="cursor:pointer"></b-img>
      </div> -->
      <!-- 
      <div class="row m-3 py-3" :class="getBackgroundPaneClass()" style="opacity:0.5">
          <b-embed type="video" aspect="21by9" crossorigin	playsinline autoplay loop muted poster="/images/landing/pcbpreflight_dashboard.png">
            <source src="/images/landing/initialedits29-min.mp4" type="video/mp4">
          </b-embed>
      </div>

      <h3 class="mt-1 my-3 text-center">Prevents PCB Manufacturing Failures and Common Issues<br /><span class="d-none d-lg-block font-weight-bold"><u>BEFORE Design Handoff</u></span></h3>
      <p class="d-none d-lg-block mt-1 my-3 text-center font-italic">A Free online platform built for PCB Designers, Engineers and Electronics Manufacturers worldwide!</p>
      <h4 class="d-none d-lg-block mt-1 my-3 text-center">Online CAM platform for PCB Designers, Engineers and Electronics Manufacturers!</h4>
      <h4 class="d-none d-lg-block mt-1 my-3 text-center">Next Generation Online CAM and DFM Automation</h4>
       -->
      <h3 class="d-none d-lg-block mt-1 my-3 text-center">Online CAM platform for PCB Designers, Engineers and Electronics Manufacturers</h3>

      <b-row class="m-0 py-3 px-1" :class="getBackgroundPaneClass()">
        <b-col>
          <h4 class="d-lg-none my-3 text-center w-100" :class="getBackgroundUiClass()">Next-Gen PCB DFM and CAM Automation</h4>
          <ul class="list-unstyled mt-5">
            <b-media tag="li">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/pcb-manufacturing-analysis.png" width="200" :class="getBackgroundUiClass()" alt="DFM Manufacturing Analysis" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><span class="text-success font-weight-bold mr-2">FREE!</span>Prevent PCB Failures (DFM)</h5>
              <p class="d-none d-lg-block mb-0">
                Perform DFM Analysis on your Printed Circuit Design before manufacturing.  
                DFM violations are displayed in the online Viewers' DFM Results Browser tree.
              </p>
              <p class="d-lg-none mb-0">Find issues before manufacturing.</p>
            </b-media>

            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/pcb-preflight-viewer.png" width="200" :class="getBackgroundUiClass()" alt="PCB Online Viewer" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><span class="text-success font-weight-bold mr-2">FREE!</span>Online Viewer + Collab</h5>
              <p class="d-none d-lg-block mb-0">
                Review all EDA/CAM formats (Gerber, ODB++, IPC-2581, NC, etc.) plus collaboration tools. Let PCB Preflight be your trusted EDA/CAM Viewer that runs on every platform and device!  
              </p>
              <p class="d-lg-none mb-0">Review all EDA/CAM formats.</p>
            </b-media>

            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/compare-jobs.png" width="200" :class="getBackgroundUiClass()" alt="PCB Compare Check (DIFF)" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-not-equal mr-1 fa-lg"></i>Compare PCB Designs (DIFF)</h5>
              <p class="mb-0">
                Find the differences in PCB Design revisions.
              </p>
            </b-media>

            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/advanced-dfm.png" width="200" :class="getBackgroundUiClass()" alt="Advanced DFM Checks" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-check-double mr-1 fa-lg"></i>Advanced DFM Checks</h5>
              <p class="d-none d-lg-block mb-0">
                Get powerful DFM Checks such as Acid traps, Starved Thermal, Power/Ground Short, Find Solder Bridges, etc.
              </p>
              <p class="d-lg-none mb-0">Find Acid traps, solder bridges, etc.</p>
            </b-media>

            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/pcb-electrical-analysis.png" width="200" :class="getBackgroundUiClass()" alt="NET Electrical Analysis" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-code-branch mr-1 fa-lg"></i>Find NET Shorts/Opens</h5>
              <p class="mb-0">
                Electrical Analysis to find any Shorts or Open Nets.
              </p>
            </b-media>

          </ul>
        </b-col>
        <b-col>
          <h4 class="d-lg-none my-3 text-center w-100" :class="getBackgroundUiClass()">Powerful CAM with API Automation</h4>
          <ul class="list-unstyled mt-5">

            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/api-applications.png" width="200" :class="getBackgroundUiClass()" alt="API Automation" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-magic mr-1 fa-lg"></i>APP Magic: Easy API Automation</h5>
              <p class="d-none d-lg-block mb-0">
                Build PCB Manufacturing Apps in 10 minutes or less - Just Click and Drag!
              </p>
              <p class="d-lg-none mb-0">Build Apps in 10 minutes!</p>
            </b-media>

            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/pcb-panelization.png" width="200" :class="getBackgroundUiClass()" alt="PCB Panelization + CAM Tools" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-toolbox mr-1 fa-lg"></i>CAM Tools + PCB Panelization</h5>
              <p class="d-none d-lg-block mb-0">
                Prepares a PCB design for panelization and manufacturing.
                Create fixed size and optimized panels with Tabs or Scoring<br/><b>Instantly Save money on PCB manufacturing!</b>
              </p>
              <p class="d-lg-none mb-0">Saves money on manufacturing!</p>
            </b-media>

            <!-- PCB SALES -->
            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/pcb-sales-analysis.png" width="200" :class="getBackgroundUiClass()" alt="PCB Sales Tools" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-dollar-sign mr-1 fa-lg"></i>PCB Sales Tools</h5>
              <p class="d-none d-lg-block mb-0">
                Generate Instant PCB Quotes and cost estimates. Create your own PCB pricing/quotation templates.
              </p>
              <p class="d-lg-none mb-0">Generate PCB Quotes and cost estimates.</p>
            </b-media>

            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/pcb-export-files.png" width="200" :class="getBackgroundUiClass()" alt="Export EDA/CAM Formats" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-file-export mr-1 fa-lg"></i>Convert to popular CAM/EDA formats</h5>
              <p class="d-none d-lg-block mb-0">
                Easily convert formats: Gerber, NC Drill/Rout, ODB++, IPC-2581(DMP), DXF, Numerical Workspace (*.wrk) and more.
              </p>
              <p class="d-lg-none mb-0">Gerber, NC, ODB++, IPC-2581, DXF and more.</p>
            </b-media>
            
            <b-media tag="li" class="my-4">
              <template #aside>
                <b-img thumbnail fluid src="/images/landing/assembly-check.png" width="200" :class="getBackgroundUiClass()" alt="Assembly Checks" @click="$router.push({name:'Signup'})" style="cursor:pointer;border:none;min-width:135px"></b-img>
              </template>
              <h5 class="mt-0 mb-3"><i class="fas fa-fw fa-microchip mr-1 fa-lg"></i>Assembly Checks</h5>
              <p class="d-none d-lg-block mb-0">
                Get PCB Assembly checks such as Verify Component clearances, rotation, hieght. 
                BOM File Comparison, Footprint to Pad Registration, Invalid Refdes, and more.          
              </p>
              <p class="d-lg-none mb-0">Verify Components, BOM, Footprints</p>
            </b-media>


          </ul>
        </b-col>
      </b-row>

      <!--  <h2 class="my-3 text-center"><i class="fas fa-fw fa-paper-plane pr-2"></i><span class="font-italic font-weight-bold">Fly thru PCB Manufacturing and Assembly... with PCB Preflight!</span></h2>
              <h4 class="d-none d-lg-block mt-1 my-3 text-center">Online CAM platform for PCB Designers, Engineers and Electronics Manufacturers!</h4>
      <h2 class="d-none d-lg-block mt-1 my-3 text-center">PCB Preflight - Next Generation Online CAM and DFM Automation</h2>
      PCB Preflight guarantees a PCB design is manufacturable, and prevents costly manufacturing problems or delays!
      -->
      <h3 class="d-none d-lg-block mt-1 my-3 text-center">PCB Preflight - Next Generation Online DFM and CAM Automation</h3>

      <!-- DESCRIPTION -->
      <div class="m-3 p-3" :class="getBackgroundUiClass()" style="border: 1px solid rgba(82, 87, 92,1.0)">
        <h5 class="mt-3">What is Preflight?</h5>
        <p class="lead mb-3"><a href="https://www.merriam-webster.com/dictionary/preflight" target="_blank"><b>Preflight</b></a> refers to the <span class="text-warning font-weight-bold">crucial preparatory checks done before</span> - every aircraft takeoff.</p>
        <h5 class="mt-4">What is PCB Preflight?</h5>
        <p class="lead mb-3">The <span class="text-warning font-weight-bold">crucial preparatory checks done before</span> - every design handoff to PCB manufacturing and assembly.</p> 
        <h5 class="mt-4">Why PCB Preflight?</h5>
        <p class="lead"><a href="https://www.pcbpreflight.com/landing/signup" target="_blank"><b>PCB Preflight</b></a> guarantees your PCB design is manufacturable, and prevents costly manufacturing problems or delays!</p>
        <router-link tag="button" class="btn btn-lg btn-primary mt-3" :to="{name:'Signup'}">Get started for free</router-link>
        <br/>
        <router-link :to="{name:'Login'}" tag="button" class="btn btn-lg btn-secondary mt-3">Already a member? Click here.</router-link>
      </div>

      <!-- RUNS ON  -->
      <div class="m-3 p-3"  :class="getBackgroundUiClass()">
        <p class="p-1 m-0"><b>Runs on Every Device:</b></p>
        <p class="p-1 m-0">
          <i class="fab fa-fw fa-windows"></i>Windows 
          <i class="fab fa-fw fa-linux ml-1"></i>Linux 
          <i class="fab fa-fw fa-apple ml-1"></i>MAC
          <i class="fab fa-fw fa-app-store-ios"></i>iOS
          <i class="fab fa-fw fa-google-play ml-1"></i>Android
        </p>
        <p class="p-1 m-0"><i class="fas fa-fw fa-lock mr-1 fa-lg"></i><b>Secure (256-bit AES Encryption)</b></p>
      </div>

      <!-- Icons Grid
      <section class="features-icons text-center d-none d-lg-block" :class="getBackgroundPaneClass()">
        <div class="container">
          <div class="row">
            <div class="col-4">
              <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                  <i class="icon-rocket m-auto text-light"></i>
                </div>
                <h3>PCB market is Growing!</h3>
                <p class="lead mb-0">and globally projected to exceed <b>$100 Billion by 2030</b><sup>1</sup></p>
              </div>
            </div>
            <div class="col-4">
              <div class="features-icons-item mx-auto mb-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                    <i class="icon-arrow-down-circle m-auto text-light"></i>
                </div>
                <h3>PCB Failures are a Significant Concern</h3>
                <p class="lead mb-0">Companies lose millions in redesigns, <a class="font-weight-bold" target="_blank" href="https://www.autoevolution.com/news/2024-kia-sportage-recalled-over-shorting-circuit-board-235310.html">embarrassing product recalls</a> and damaged reputations.</p>
              </div>
            </div>
            <div class="col-4">
              <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                  <i class="icon-badge m-auto text-light"></i>
                </div>
                <h3>PCB Preflight Verification</h3>
                <p class="lead mb-0">Using PCB Preflight ensures PCBs are built correctly the first time!</p>
              </div>
            </div>
          </div>
        </div>
        <p class="small mt-2"><sup>1</sup> Market size estimate per Google - June 2025</p>
      </section>
       -->
      <!-- Icons Grid -->

      <!-- Call to Action -->
      <section class="text-white text-center" :class="getBackgroundPaneClass()">
        <div class="col-12">
          <router-link tag="button" class="btn btn-lg btn-primary my-3" :to="{name:'Signup'}">Get started for Free!</router-link>
        </div>
      </section>

    </div>

    <!-- Footer -->
    <page-footer>
    </page-footer>
    <!-- Footer -->
  
  </main>
</template>

<style>

  /* TOOLBAR BUTTON COLORS*/
  .black-toolbar-ui {
    color: white;
    background-color:rgba(59, 67, 82,1.0) !important;
  }

  .black-pane-ui {
    color: white;
    background-color:rgba(82, 87, 92,1.0) !important;
  }

  .white-toolbar-ui {
    color: #343a40;
    background-color:#6c757d55 !important;
  }

  .white-pane-ui {
    color: #343a40;
    background-color:#f8f9fa !important;
  }

  /* Computer Screens */
  @media (min-width: 992px) 
  {
    #dashboardJobs
    {
      overflow-y:scroll;
      height:calc(100vh - 82px);
    }

    #dashboardPanelLeft
    {
      width:225px;
      height:calc(100vh - 65px);
    }

    #dashboard-folder-dropdown
    {
      width:calc(100vw - 242px);
    }

    .hero-height {
      min-height:500px;
    }
  }

  /* Phone Screens */
  @media (max-width: 991px) 
  {
      #dashboardJobs
      {
        overflow-y:scroll;
        height:calc(100vh - 120px);
      }


    #dashboard-folder-dropdown
    {
      width:100%;
    }

    .hero-height {
      min-height:300px;
    }

  }

</style>

<script>
  import PageHeader from '../components/PageHeader.vue';
  import PageFooter from '../components/PageFooter.vue';
  import Common from '../mixins/Common'

  export default {

    mixins: [Common],

    //--------------------------------------------------------------------//

    components: 
    {
      PageHeader,
      PageFooter,
    },
    
    //--------------------------------------------------------------------//

    data() 
    {
      return {
        bTouchDevice: false,
        moment,
        bgcolor: '#202329',
        resultJobs: null,
        bDashboardThemeDarkMode: true,  //Force Dark mode for now
      }
    },

    //--------------------------------------------------------------------//

    mounted() {
      app = this;
      document.title = "PCB Preflight";
    },

    methods: {

    //--------------------------------------------------------------------//

    getBackgroundUiClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'white-toolbar-ui';
      }
      else 
      {
        return 'black-toolbar-ui';
      }
    },

    //--------------------------------------------------------------------//
    
    getBackgroundPaneClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'white-pane-ui';
      }
      else 
      {
        return 'black-pane-ui';
      }
    },

    //--------------------------------------------------------------------//
    
    getTextUiClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'text-dark bg-light';
      }
      else 
      {
        return 'text-light bg-dark';
      }
    },

    //--------------------------------------------------------------------//
    
    getBorderUIClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'text-dark bg-light border-light';
      }
      else 
      {
        return 'text-light bg-secondary border-secondary';
      }
    },

    //--------------------------------------------------------------------//
    



    }

  }
</script>
